import React, { useContext, useState } from "react";
import { Button, Table } from "react-bootstrap";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import iconfromto from "../../assets/images/icon-fromto.png";

const FancyBetTypeListing = ({ title, data }) => {
  let { user } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <div className="risk-management-table">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h2 className="common-heading">{title}</h2>
        <div>
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            Download
          </Button>{" "}
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            <i  style={{transform:"rotateY(180deg)"}} className="fas fa-redo-alt"></i>
          </Button>
        </div>
      </div>
      <div className="account-table match-odd-table">
        <div className="responsive">
          <Table>
            <thead>
              <tr>
                <td width="10%" rowSpan="2">
                  <strong> Sports</strong>
                </td>
                <td width="10%" rowSpan="2">
                  <strong> Market Date</strong>
                </td>
                <td rowSpan="2">
                  <strong>Event/Market Name</strong>
                </td>
                {/* <td
                  width="21%"
                  className="text-center border-l bg-light-yellow"
                  colSpan="3"
                >
                  <strong>Player P/L</strong>
                </td> */}
                <td width="10%" rowSpan="2" className="text-center">
                  <strong> Matched Amount</strong>
                </td>
              </tr>
            </thead>
            <tbody className="match-tbody">
              {data?.length > 0 ? (
                data.map((res, index) => {
                  return (
                    <>
                      <tr>
                        <td className="text-center">
                          <Link className="blue-text"     to={`/DownlinePnl-sport-premium/${res?.eventId}/${res?.selectionId}/${res?.marketId}/${user?.userType}/${user?._id}`}
                            target="_blank"
                              >{`${
                            res?.eventType === "4"
                              ? "Cricket"
                              : res?.eventType === "1"
                              ? "Soccer"
                              : res?.eventType === "2"
                              ? "Tennis"
                              : "Casino"
                          }`}</Link>
                        </td>
                        <td className="text-center">
                        {helpers.matchDateTimeNew(
                            res.timeInserted,
                            user.timeZone
                          )}
                        </td>
                        <td className="bg-yellow border-0 risk-match-name">
                          <a>
                            {/* <Button
                              style={{
                                padding: "3px 5px",
                                fontSize: "12px",
                                marginRight: "5px",
                              }}
                              onClick={() =>
                                navigate(
                                  `/match-details/${res?.eventId}/${res?.marketId}`
                                )
                              }
                            >
                              View Details
                            </Button> */}
                            <strong>
                              <Link
                                // to={`/match-details/${res?.eventId}/${res?.marketId}`}
                              >
                                {res?.matchName}
                              </Link>
                            </strong>{" "}
                            <span className="ms-3">{res?.fancyName} </span>
                          </a>
                        </td>
                        <td className="border-0 bg-yellow text-right-match">
                          <p className="">
                            {res?.positionLoseAmount
                              ? res?.positionLoseAmount.toFixed(2)
                              : 0}
                          </p>
                        </td>

                        {/* <td className="border-0 bg-yellow"></td> */}

                        {/* <td className="border-0 bg-yellow text-right-match">
                          <p className="text-success">
                            {res?.positionProfitAmount
                              ? res?.positionProfitAmount
                              : 0}
                          </p>
                        </td> */}
                        {/* <td className="border-right-0 text-center">
                          <Link
                            to={`/DownlinePnl-sport-premium/${res?.eventId}/${res?.selectionId}/${res?.marketId}/${user?.userType}/${user?._id}`}
                            target="_blank"
                            className="green-btn"
                          >
                            {"Book"}
                          </Link>
                        </td> */}
                      </tr>

                      {/* {index + 1 == id ? (
                          <FancyListDropdown
                            showMatch={showMatch}
                            data={res?.jsonData}
                            selectData={selectData}
                          />
                        ) : (
                          ""
                        )} */}
                    </>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7}>No Data</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export default FancyBetTypeListing;
